<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b>Asignar Categoria Moodle Modulo</b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <!-- <p> {{modulo}} </p> -->
          <p> <b>ID categoria: </b> {{categoria.id}} </p>
          <p> <b>Nombre: </b> {{categoria.nombre}} </p>

          <small>Selecciona el modulo:</small>
          <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>
          <multiselect class="form-control xinput input-group-sm" v-model="curso" id="id" label="nombre" 
            track-by="id" placeholder="Ingrese el Nombre o documento (4 letras minimo)..." open-direction="bottom" 
            :options="datos" :multiple="false" :searchable="true" :loading="isLoading" :internal-search="true" 
            :clear-on-select="true" :close-on-select="true" :options-limit="300" :limit="15" 
            :max-height="600" :show-no-results="true" :hide-selected="false" :show-labels="false">

            <template slot="tag" slot-scope="{ option, remove }"><span class="custom__tag"><span>{{ parseLabel(option) }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="curso==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
            </template>
            <span slot="noResult">No se encontraron categorias con ese nombre</span>
          </multiselect>
        </div>
        
        <Alertas 
          ref="alertar" 
          v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
          v-bind:msgLoading="'Aplicando...'"
        />
        <div class="modal-footer">
          <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError} from '@/components/Utils.js'

export default {
  props:{ modulo:{type:Object,required:true},xprograma:{type:Object,required:true} },// {pid,ccid,tag}
  data(){
    return{
      timeoutHnd: 0,
      activo:true,
      isLoading: false,
      curso:null,
      categoria:{},
      datos:[],
      msg:'',
    }
  },
  components:{ Alertas },
  methods:{
    buscar() {
      if( this.isLoading ) return;
      var vue = this;
      vue.isLoading = true;
      vue.datos = [];

      var cuerpo = {
        "data":{
          "id": this.xprograma.course_category_id
        }
      };
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"get-course-category/";
      // window.console.log( "DATA> ",data );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          // window.console.log('------------ RESPUESTA DEL SERVIDOR ------------')
          // window.console.log( ">> ",window.stringifyObject(res),res )
          vue.isLoading = false;
          vue.msg = "";
          vue.categoria.id = res.data.category.id;
          vue.categoria.nombre = res.data.category.name;
          var dts = [];
          res.data.category.courses.forEach( function(e){
            dts.push( {id:e.id,nombre:e.id+' - '+e.fullname,shortname:e.shortname,visible:e.visible} );
          });
          vue.datos = dts;
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
      });
    },
    submit(){
      if( !this.curso ){
        return;
      }
      var vue = this;
      this.$refs.alertar.cargando();
      var input = { idmodulo:this.modulo.pid,idprograma:this.xprograma.id,course_id:this.curso.id };
      var sql = gql`mutation{ asignarCourseProgramaModulo(input:${window.stringifyObject(input)}){ ok,errors{message} } }`
      window.console.log( sql );

      this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        this.$refs.alertar.reset();
        var res = data.data.asignarCourseProgramaModulo;
        window.console.log( res )
        if( res.ok ){
          this.modulo.tag.course_id =this.curso.id;
          window.$('#modal-cate-modulo').modal('hide')
        }
        
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        window.console.error(error)
        vue.isLoading = false;
        vue.msg = "...";
        vue.$notify( parseJsonError( error,'getEstudiantesByDoc' ) )
      })
    },
  },
  mounted(){
    var vue = this;
    window.$('#modal-cate-modulo').on('show.bs.modal', function () {
      vue.buscar();
    })
  }
}
</script>